// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2YDpy";
var _3 = "header__text-XYFww";
var _4 = "description-2k-ad";
var _5 = "passengers-4D9Mx";
var _6 = "item-2XZRs";
var _7 = "passengerType-1ZFYo";
var _8 = "age-XzPT4";
var _9 = "info__icon-2m-Ao";
var _a = "increase-Qk_Yc";
var _b = "decrease-3Ds89";
var _c = "counter-2AEv6";
var _d = "notification-2b0N5";
var _e = "text-1xbuk";
var _f = "buttons-28Fsh";
var _10 = "newSearch-CkLmu";
var _11 = "continueButton-3vREp";
export { _1 as "__esModule", _2 as "container", _3 as "header__text", _4 as "description", _5 as "passengers", _6 as "item", _7 as "passengerType", _8 as "age", _9 as "info__icon", _a as "increase", _b as "decrease", _c as "counter", _d as "notification", _e as "text", _f as "buttons", _10 as "newSearch", _11 as "continueButton" }
export default { "__esModule": _1, "container": _2, "header__text": _3, "description": _4, "passengers": _5, "item": _6, "passengerType": _7, "age": _8, "info__icon": _9, "increase": _a, "decrease": _b, "counter": _c, "notification": _d, "text": _e, "buttons": _f, "newSearch": _10, "continueButton": _11 }
